import { ButtonLink, type Color, type Size, type Variant } from '@sortlist-frontend/design-system/legacy';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import type { ReactElement } from 'react';

import { useBriefingLink } from '_components/Briefing/hooks/useBriefingLink';
import { BriefingCTA } from '_components/Briefing/types';
import { briefingConfig } from '_components/Briefing/utils';

export interface BriefingButtonProps {
  cta?: BriefingCTA;
  truncate?: boolean;
  size?: Size;
  buttonStyle?: Color;
  buttonVariant?: Variant;
  className?: string;
  label?: string | ReactElement;
  dataTestid?: string;
}

export const BriefingButton = (props: BriefingButtonProps) => {
  const { size, buttonStyle, buttonVariant, className, label, dataTestid, cta, ...restProps } = props;

  const { t } = useTranslation(briefingConfig.i18nNamespaces);
  const briefingLink = useBriefingLink({ cta });

  return (
    <ButtonLink
      data-testid={dataTestid ?? 'briefing-button'}
      size={size ?? 'sm'}
      buttonStyle={buttonStyle ?? 'primary'}
      buttonVariant={buttonVariant ?? 'raised'}
      label={label ?? t('briefing:buttonLabel')}
      className={className}
      {...restProps}
      {...briefingLink}
    />
  );
};
